import React from 'react';
import { InlineError } from '@box/blueprint-web';
import css from './new-form-element.module.scss';

type BuilderInlineErrorContextProviderProps = {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  children: any;
  errorMsg?: string;
  elementId: string;
};
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const defaultValue: Record<string, any> = {};
const BuilderInlineErrorContext =
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2345
  React.createContext<BuilderInlineErrorContextProviderProps>(defaultValue);

const BuilderInlineErrorContextProvider = ({
  children,
  errorMsg,
  elementId,
}: BuilderInlineErrorContextProviderProps) => {
  const props = React.useMemo(
    () => ({ children, errorMsg, elementId }),
    [children, errorMsg, elementId],
  );
  return (
    <BuilderInlineErrorContext.Provider value={props}>
      {children}
    </BuilderInlineErrorContext.Provider>
  );
};

const BuilderInlineError = ({
  className = css.bottomError,
}: {
  className?: string;
}) => {
  const { errorMsg, elementId } = React.useContext(BuilderInlineErrorContext);
  return errorMsg ? (
    <InlineError
      className={className}
      data-testid={`${elementId}-builder-inline-error`}
      id={`${elementId}-builder-inline-error`}
    >
      {errorMsg}
    </InlineError>
  ) : null;
};

export {
  BuilderInlineError,
  BuilderInlineErrorContextProvider,
  BuilderInlineErrorContext,
};
